import { useRef, useState } from "react";
import Logo from 'assets/images/logo.png';
import { Link } from "react-router-dom";
import useClickOutside from "utils/clickOutside";


const MobileNav = ({ setShowSideNav , showSideNav }) => {
    const sideNavRef = useRef(null);
    useClickOutside(sideNavRef , () => setShowSideNav(false));

    return (
        <div 
        className={` sm-nav ${showSideNav ? 'show' : ''} sm-nav-shadow fixed top-0 left-0 sm:w-[300px] w-[250px] h-screen bg-pure z-50 py-4 px-4`}
        ref={sideNavRef}
        >
            <div className='flex justify-between'>
                    <div>
                        <img src={Logo} alt="" className="w-[120px]"/>
                    </div>
                    <div className='w-fit cursor-pointer'
                    onClick={() => setShowSideNav(false)}
                    >
                        <i className="uil uil-times text-2xl "></i>
                    </div>
                </div>
                <div className='mt-8'>
                    <ul className='flex flex-col gap-4'>
                        <Link to='/' onClick={() => setShowSideNav(false)}>
                            <li className='border-b-2 border-b-gray-300 py-2 px-2 hover:bg-primary hover:text-white duration-200 ease-in-out cursor-pointer flex items-center justify-between '>
                                <p>Home</p>
                                <i className="uil uil-angle-double-right text-2xl"></i>
                            </li>
                        </Link>
                        <Link to='/about' onClick={() => setShowSideNav(false)}>
                            <li className='border-b-2 border-b-gray-300 py-2 px-2 hover:bg-primary hover:text-white duration-200 ease-in-out cursor-pointer flex items-center justify-between'>
                                <p>About</p>
                                <i className="uil uil-angle-double-right text-2xl"></i>
                            </li>
                        </Link>
                        <Link to='/working' onClick={() => setShowSideNav(false)}>
                            <li className='border-b-2 border-b-gray-300 py-2 px-2 hover:bg-primary hover:text-white duration-200 ease-in-out cursor-pointer flex items-center justify-between'>
                                <p>How It Works</p>
                                <i className="uil uil-angle-double-right text-2xl"></i>
                            </li>
                        </Link>
                        <Link to='/inventory' onClick={() => setShowSideNav(false)}>
                            <li className='border-b-2 border-b-gray-300 py-2 px-2 hover:bg-primary hover:text-white duration-200 ease-in-out cursor-pointer flex items-center justify-between'>
                                <p>Inventory</p>
                                <i className="uil uil-angle-double-right text-2xl"></i>
                            </li>
                        </Link>
                        <Link to='/contact' onClick={() => setShowSideNav(false)}>
                            <li className='border-b-2 border-b-gray-300 py-2 px-2 hover:bg-primary hover:text-white duration-200 ease-in-out cursor-pointer flex items-center justify-between'>
                                <p>Contact</p>
                                <i className="uil uil-angle-double-right text-2xl"></i>
                            </li>
                        </Link>
                        <Link to='/user/dashboard' onClick={() => setShowSideNav(false)}>
                            <li className='border-b-2 border-b-gray-300 py-2 px-2 hover:bg-primary hover:text-white duration-200 ease-in-out cursor-pointer flex items-center justify-between'>
                                <p>Login</p>
                                <i className="uil uil-angle-double-right text-2xl"></i>
                            </li>
                        </Link>
                        <Link to='/register' onClick={() => setShowSideNav(false)}>
                            <li className='border-b-2 border-b-gray-300 py-2 px-2 hover:bg-primary hover:text-white duration-200 ease-in-out cursor-pointer flex items-center justify-between'>
                                <p>Register</p>
                                <i className="uil uil-angle-double-right text-2xl"></i>
                            </li>
                        </Link>
                    </ul>
                </div>
                <div className='mt-12 flex items-center gap-4 justify-center'>
                    <div className='bg-blue-800 text-white rounded-full w-[40px] h-[40px] flex items-center justify-center cursor-pointer hover:translate-y-[-5px] duration-200 ease-in-out'>
                        <a href="/">
                            <i className="uil uil-facebook-f text-xl"></i>
                        </a>
                    </div>
                    <div className='bg-rose-500 text-white rounded-full w-[40px] h-[40px] flex items-center justify-center cursor-pointer hover:translate-y-[-5px] duration-200 ease-in-out'>
                        <a href="/">
                            <i className="uil uil-instagram text-xl"></i>
                        </a>
                    </div>
                    <div className='bg-blue-500 text-white rounded-full w-[40px] h-[40px] flex items-center justify-center cursor-pointer hover:translate-y-[-5px] duration-200 ease-in-out'>
                        <a href="/">
                            <i className="uil uil-twitter text-xl"></i>
                        </a>
                    </div>
                    <div className='bg-red-700 text-white rounded-full w-[40px] h-[40px] flex items-center justify-center cursor-pointer hover:translate-y-[-5px] duration-200 ease-in-out'>
                        <a href="/">
                            <i className="uil uil-youtube text-xl"></i>
                        </a>
                    </div>
                </div>
        </div>
    )
}

export default MobileNav;